import {Subject} from 'rxjs';
import {Hlsjs} from './hlsjs';
import {MultiBitrate} from './playable';
import {MultipleBitratesWithAuto, Qualities, Quality, SingleBitrate} from './qualities';

const BASE = 'https://hls.goodgame.ru/lhls_adaptive/%s/';
const MASTER_URL = BASE + 'playlist.m3u8';
const URLS = {
  [Qualities.SOURCE]: BASE + '%s_prem/chunks.m3u8',
  [Qualities.HIGH]: BASE + '%s_720/chunks.m3u8',
  [Qualities.MEDIUM]: BASE + '%s_480/chunks.m3u8',
  [Qualities.LOW]: BASE + '%s_240/chunks.m3u8',
};

export class GGHls extends Hlsjs implements MultiBitrate {
  qualities$ = new Subject<Quality[]>();
  currentQuality$ = new Subject<Quality>();

  protected isMultibitrate = false;
  protected src: string;
  private _url: string;
  private retryTimeout: number;

  constructor() {
    super();

    this.currentQuality$.subscribe(q => this.changeQuality(q));
  }

  getUrl(streamkey, quality = Qualities.SOURCE) {
    if (!streamkey) {
      return '';
    }

    return MASTER_URL.replace('%s', streamkey);

    // if (!this.isMultibitrate || !URLS[quality]) {
    //   quality = Qualities.SOURCE;
    // }
    //
    // return URLS[quality].replace(/%s/g, streamkey);
  }

  loadSource(src: string) {

    if (!src) {
      return false;
    }
    this.src = src;
    this.checkQualities(src);
  }

  switchToQuality(quality: Quality) {
    this.currentQuality$.next(quality);
  }

  destroy() {
    super.destroy();
    this.hls.destroy();
  }

  stop() {
    if (this.retryTimeout) {
      clearTimeout(this.retryTimeout);
    }
    super.stop();
  }

  protected async checkQualities(src: string) {
    try {
      const res = await fetch(MASTER_URL.replace('%s', src));
      const m3u8 = await res.text();

      const qCount = m3u8.split('#EXT-X-STREAM-INF').length;

      try {
        const urls = m3u8.split('#EXT-X-STREAM-INF').filter(l => l.indexOf('.m3u8') !== -1).map(l => BASE + l.split('\n')[1]);
        URLS[Qualities.SOURCE] = urls[0];
        URLS[Qualities.HIGH] = urls[1] || '';
        URLS[Qualities.MEDIUM] = urls[2] || '';
        URLS[Qualities.LOW] = urls[3] || '';

        console.log('Updated urls:', URLS);
      } catch (e) {
        console.log('Failed to parse master:', e);
      }

      if (qCount > 2) {
        this.initMultibitrates();
        return;
      }
    } catch (e) {
    }

    this.initSinglebitrate();
  }

  protected initMultibitrates() {
    this.isMultibitrate = true;
    this.qualities$.next(MultipleBitratesWithAuto);
  }

  protected initSinglebitrate() {
    this.isMultibitrate = false;
    this.qualities$.next(SingleBitrate);
  }

  protected setupWatchDog() {
    // let lu = 0;
    // //
    // this.hls.on('hlsLevelUpdated', () => {
    //   lu++;
    //   if (lu >= 3 && this.video.currentTime === 0) {
    //     // console.log('stuck?');
    //     this.logError('Stuck on level update! Restarting...');
    //     super.loadSource(this._url);
    //   }
    // });
    // this.hls.on('hlsFragLoading', () => lu = 0);
  }

  protected reportSpeed(speed: number) {
    super.reportSpeed(speed);

    if (this.hls.latency < -10) {
      this.log$.next('Negative latency detected! Reload video');
      super.loadSource(this._url);
    }
  }

  protected retryAfterDelay() {
    this.retryTimeout = setTimeout(() => {
      this.logError('Try once again');
      super.loadSource(this._url);
    }, 5000);
  }

  private changeQuality(quality: Quality) {
    // console.log(quality, this._url);

    if (!this.src) {
      return;
    }

    // if (!this._url) {
    this._url = this.getUrl(this.src, quality);
    super.loadSource(this._url);
    // }

    if (this.isMultibitrate) {
      const levels = {[Qualities.AUTO]: -1, [Qualities.SOURCE]: 3, [Qualities.HIGH]: 2, [Qualities.MEDIUM]: 1, [Qualities.LOW]: 0};
      this.hls.currentLevel = levels[quality];
    } else {
      this.hls.currentLevel = -1;
    }
  }

}
